import React, { useState, useEffect } from 'react';
import './HomePage.css';
import BackgroundSection from './BackgroundSection';
import ToolsSection from './ToolsSection';
import Footer from "./Footer";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faChevronDown } from '@fortawesome/free-solid-svg-icons';

const HomePage = () => {
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isHovered, setIsHovered] = useState(false); 
  const [isScrolled, setIsScrolled] = useState(false); 

  useEffect(() => {
    let timer;
    if (!isHovered) {
      timer = setTimeout(() => setActiveDropdown(null), 200); 
    }
    return () => clearTimeout(timer);
  }, [isHovered]);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleMouseEnter = (menu) => {
    setActiveDropdown(menu);
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  return (
    <div className="homepage-container">
      <div className="top-bar">
      <a href="https://outreachdigitalmarketing.com/" className="logo-link">
          <img 
            src="/logo.svg" 
            alt="Logo" 
            className={`logo ${isScrolled ? 'scrolled' : ''}`} 
          />
        </a>
        <div className="menu">

          <div
            className="menu-item-container"
            onMouseEnter={() => handleMouseEnter('about-us')}
            onMouseLeave={handleMouseLeave}
          >
            <a href="https://outreachdigitalmarketing.com/about-us/" className="menu-item">
              ABOUT US <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon" />
            </a>
            {activeDropdown === 'about-us' && (
              <div className="dropdown">
                <div className="dropdown-highlight"></div>
                <a href="https://outreachdigitalmarketing.com/seo-company-westlake-village/" className="dropdown-item">BUSINESS BENEFITS OF AN SEO COMPANY</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/digital-marketing-agency-westlake-village/" className="dropdown-item">DECIDE IF YOU NEED A DIGITAL MARKETING AGENCY</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/seo-agency-westlake-village/" className="dropdown-item">WHAT DOES AN SEO AGENCY DO?</a>
              </div>
            )}
          </div>


          <div
            className="menu-item-container"
            onMouseEnter={() => handleMouseEnter('what-we-do')}
            onMouseLeave={handleMouseLeave}
          >
            <a href="https://outreachdigitalmarketing.com/#" className="menu-item">
              WHAT WE DO <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon" />
            </a>
            {activeDropdown === 'what-we-do' && (
              <div className="dropdown">
                <div className="dropdown-highlight"></div>
                <a href="https://outreachdigitalmarketing.com/analytics/" className="dropdown-item">ANALYTICS</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/blog-creation/" className="dropdown-item">BLOG CREATION</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/email-marketing/" className="dropdown-item">EMAIL MARKETING</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/local-marketing/" className="dropdown-item">LOCAL MARKETING</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/pay-per-click/" className="dropdown-item">PAY PER CLICK</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/review-management/" className="dropdown-item">REVIEW MANAGEMENT</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/search-engine-optimization/" className="dropdown-item">SEARCH ENGINE OPTIMIZATION</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/social-media-marketing/" className="dropdown-item">SOCIAL MEDIA MARKETING</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/video-production/" className="dropdown-item">VIDEO PRODUCTION</a>
                <div className="dropdown-divider"></div>
                <a href="https://outreachdigitalmarketing.com/website-development/" className="dropdown-item">WEBSITE DEVELOPMENT</a>
              </div>
            )}
          </div>


          <div
            className="menu-item-container"
            onMouseEnter={() => handleMouseEnter('marketing-strategy')}
            onMouseLeave={handleMouseLeave}
          >
            <a href="https://outreachdigitalmarketing.com/marketing-department/" className="menu-item">
              MARKETING STRATEGY <FontAwesomeIcon icon={faChevronDown} className="dropdown-icon" />
            </a>
            {activeDropdown === 'marketing-strategy' && (
              <div className="dropdown">
                <div className="dropdown-highlight"></div>
                <a href="https://outreachdigitalmarketing.com/marketing-check-up/" className="dropdown-item">MARKETING CHECK UP</a>
              </div>
            )}
          </div>
          <a href="https://tools.outreachdigitalmarketing.com/" className="menu-item">TOOLS</a>
          <a href="https://outreachdigitalmarketing.com/reviews/" className="menu-item">REVIEWS</a>
          <a href="https://outreachdigitalmarketing.com/blog/" className="menu-item">BLOG</a>
          <a href="https://outreachdigitalmarketing.com/contact-us/" className="menu-item">CONTACT US</a>
          <a href="https://outreachdigitalmarketing.com/website-support/" className="support-button">SUPPORT</a>
          <div className="contact-info">
            <FontAwesomeIcon icon={faPhone} className="phone-icon" />
            <a href="tel:8056246646" className="phone-number">805-624-6646</a>
          </div>
        </div>
      </div>
      <BackgroundSection />
      <ToolsSection />
      <Footer />
    </div>
  );
};

export default HomePage;
